const routeTitle = {
	documentsList: 'Dokumente {sep} Liste',
	documentsGroup: 'Dokumente {sep} Gruppe',
	roles: 'Personenfunktionen',
	persons: 'Personen',
	documents: 'Dokumente',
	buildings: 'Liegenschaften',
	units: 'Einheiten',
	invoices: 'Rechnungen',
	meters: 'Zähler',
	craftsmanTasks: 'Handwerkeraufträge',
	tasks: 'Wiedervorlagen',
	openRequests: 'Offene Anfragen',
	reports: 'Meldungen',
	analysis: 'Auswertung',
	notifications: 'Benachrichtigungen',
	createTeammember: 'Teammitglied anlegen',
	updateTeammember: 'Teammitglied aktualisieren',
	documentTypes: 'Dokumentenarten',
	notesTypes: 'Notizarten',
	createNotesType: 'Notizart anlegen',
	updateNotesType: 'Notizart bearbeiten',
	definitions: 'Definitionen',
	createHandovertemplate: 'Übergabeprotokoll Vorlage anlegen',
	updateHandovertemplate: 'Übergabeprotokoll Vorlage bearbeiten',
	createReportType: 'Meldungsart definieren',
	updateReportType: 'Meldungsart bearbeiten',
	createReportStatus: 'Meldungsstatus definieren',
	updateReportStatus: 'Meldungsstatus bearbeiten',
	createReporttypeSubcategory: 'Unterkategorie definieren',
	updateReporttypeSubcategory: 'Unterkategorie bearbeiten',
	subscriptions: 'Abos',
	buildingVisibility: 'Objekt-Sichtbarkeit',
	syncFailures: 'Sync-Fehler',
	accessRejections: 'Abgelehnte Zugänge',
	createFaqCategory: 'FAQ Kategorie anlegen',
	editFaqCategory: 'FAQ Kategorie bearbeiten',
	createFaqEntry: 'FAQ Eintrag anlegen',
	editFaqEntry: 'FAQ Eintrag bearbeiten',
	profileChangePassword: '@:component.profile.change_password',
	profileUpdateRequest: '@:component.profile.updateRequest.title',
	profileUploadPicture: 'Profilbild hinterlegen',
	profileAccount: '@:component.profile.name',
	profileMyAccounts: '@:component.profile.my_accounts',
}

export default routeTitle
